import { Logger } from './Logger';
import type { LoggingConfig } from './config';

let loggerInstance: Logger | null = null;

export function initializeLogger(config: LoggingConfig): Logger {
  loggerInstance = new Logger(config);
  return loggerInstance;
}

export function getLogger(): Logger {
  if (!loggerInstance) {
    throw new Error(
      'Logger not initialized. Call initializeLogger() before using the logger.'
    );
  }
  return loggerInstance;
}

export const logger: Logger = new Proxy({} as Logger, {
  get(_, prop: string | symbol) {
    const instance = getLogger();
    const value = instance[prop as keyof Logger];
    if (typeof value === 'function') {
      return value.bind(instance);
    }
    return value;
  },
});

export type { LogContext, LogLevel } from './types';
export type { LoggingConfig } from './config';
export { Logger } from './Logger';
